<template>
    <div class="c-acceptation-controls"
        :data-component-name="$options.name"
    >
        <div class="c-acceptation-controls-row" v-if="!canceled && (!$attrs || !$attrs.value)">
            <q-btn
                :key="i"
                v-for="(option, i) in options"
                @click.stop="acceptation(option)"
                :label="option.label"
                rounded
                dense
                no-caps
                :color="option.color"
                :class="'o-button q-ml-md'"
                :icon-right="option.icon"
                :outline="outline"
                :size="size"
                :disable="assignmentError ? true : false"
            >
            </q-btn>
        </div>
        <q-btn
            :size="size"
            v-else-if="canceled"
            :outline="outline"
            label="Ne plus afficher"
            rounded
            dense
            no-caps
            color="grey-8"
            class="o-button -canceled"
            icon-right="block"
            @click="$emit('confirm-cancel')"
        > 
        </q-btn>
        <q-btn-dropdown
            :label="$attrs.value.label"
            rounded
            dense
            no-caps
            :class="'o-button '+ $attrs.value.currentClass"
            :icon="$attrs.value.icon"
            :disable="assignmentError ? true : false"
            v-else
        >
            <q-list
                size="sm"
                dense
            >
                <q-item clickable v-close-popup
                    :key="i"
                    v-for="(option, i) in options"
                    @click="acceptation(option)"
                >
                    <q-item-section

                    >
                        <q-item-label>{{ option.label }}</q-item-label>
                    </q-item-section>

                    <q-item-section avatar
                        v-if="option.icon"      
                    >
                        <q-avatar size="sm" :icon="option.icon" :color="option.color" text-color="white" />
                    </q-item-section>

                </q-item>
            </q-list>
        </q-btn-dropdown>

        <q-dialog v-model="prompt"
            ref="promptDialog"
        >
            <q-card style="min-width: 350px">
                <q-card-section>
                    <div class="text-h6">Commentaires</div>
                </q-card-section>

                <q-card-section class="q-pt-none">
                    <Input :required='true' type="textarea" autogrow v-model="reason" autofocus @keyup.enter="prompt = false" />
                </q-card-section>

                <q-card-actions align="right" class="text-primary">
                    <q-btn flat label="Annuler" v-close-popup />
                    <q-btn flat label="Continuer" @click.stop="confirmDeny()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

    </div>
</template>

<script>
    import QBtnDropdown from 'quasar'
    export default {
        name: 'AcceptationSelect',
        extends: QBtnDropdown,
        //components: { Component1, Component2 },
        props: {
            userProfileID: {
                type: [String, Number],
                default: null
            },
        	acceptButton:{
        		type: [String, Boolean],
        		default: 'Accepter',
        	},
        	denyButton:{
        		type: [String, Boolean],
        		default: 'Refuser',
        	},
        	maybeButton:{
        		type: [String, Boolean],
        		default: false,
            },
            outline: {
                type: Boolean,
                default: false
            },
            size: {
                type: String,
                default: null
            },
            lastDenyReason: {
                type: String,
                default: null
            },
            assignmentError: {
                type: [Object, Boolean],
                default: null
            },
            canceled: {
                type: String,
                default: null
            },
            myUserProfileRole: {
                type: String,
                default(){
                    return window.myUserProfileRole
                }
            },
            myUserProfileID: {
                type: String,
                default(){
                    return window.myUserProfileID
                }
            },
        },
        data(){
        	return {
                options: [],
                prompt: false,
                currentOption: null,
                reason: ''
        	}
        },
        mounted() {
            this.options=[];
            this.reason=this.lastDenyReason;
            if(this.myUserProfileRole!='ADMINISTRATOR' && this.myUserProfileID!=this.userProfileID) return;

            if(this.acceptButton) this.options.push({
                label: this.acceptButton,
                value: 'accept',
                color: 'green',
                icon: 'thumb_up',
                reason: '',
            })
            if(this.denyButton) this.options.push({
                label: this.denyButton,
                value: 'deny',
                color: 'red',
                icon: 'thumb_down',
                reason: '',
            })
            if(this.maybeButton) this.options.push({
                label: this.maybeButton,
                value: 'maybe',
                color: 'blue',
                icon: 'help',
                reason: '',
            })

            if(!this.$attrs.value) this.options=this.options.reverse();
        },
        // computed: {
        //     optionsList: function(){
        //         if(this.options) return this.options
        //     }
        // },
        watch: {
            $attrs: function(){
                this.reason=this.lastDenyReason;
                this.options=[];

                if(this.myUserProfileRole!='ADMINISTRATOR' && this.myUserProfileID!=this.userProfileID) return;

                if(this.acceptButton && this.$attrs.value?.value !="accepted") this.options.push({
                    label: this.acceptButton,
                    value: 'accept',
                    color: 'green',
                    icon: 'thumb_up',
                    reason: '',
                })
                if(this.denyButton && this.$attrs.value?.value !="denied") this.options.push({
                    label: this.denyButton,
                    value: 'deny',
                    color: 'red',
                    icon: 'thumb_down',
                    reason: '',
                })
                if(this.maybeButton && this.$attrs.value?.value !="maybe") this.options.push({
                    label: this.maybeButton,
                    value: 'maybe',
                    color: 'blue',
                    icon: 'help',
                    reason: '',
                })

                if(!this.$attrs.value) this.options=this.options.reverse();

            }
        },
        methods: {
            confirmDeny(){
                if(!this.reason || this.reason==""){
                    this.$refs.promptDialog.shake();
                    return false;
                }
                this.currentOption.reason=this.reason;
                this.$refs.promptDialog.hide();
                this.$emit('accept-assignment', this.currentOption)
            },
            acceptation(option){
                if(option.value=="deny" || option.value=="maybe"){
                    this.currentOption=option;
                    this.prompt=true;
                    return;
                }
                this.$emit('accept-assignment', option)
            }
        },
    }
</script>